import { render, staticRenderFns } from "./ObservacoesGeraisCartao.vue?vue&type=template&id=0a72c863&scoped=true"
import script from "./ObservacoesGeraisCartao.vue?vue&type=script&setup=true&lang=js"
export * from "./ObservacoesGeraisCartao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ObservacoesGeraisCartao.vue?vue&type=style&index=0&id=0a72c863&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a72c863",
  null
  
)

export default component.exports